import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import weui from "weui.js";
import {
  Button,
  IconCancel,
  IconSuccess,
  Preview,
  PreviewBody,
  PreviewItem
} from "../../components/weui";
import { orderService } from "../../services/orderService";
import { urls } from "../../urls";
import { 
  formatCurrency,
  formatDateTime,
  getAxiosError
} from "../../utils";

export const PayResult = (props) => {
  const navigate = useNavigate();
  const { orderNo } = useParams();
  const [order, setOrder] = useState(null);

  const getPayOrder = useCallback(async () => {
    const loading = weui.loading("加载中");
    try {
      const res = await orderService.getPayOrder(orderNo);
      setOrder(res.data);
    } catch (err) {
      weui.alert(getAxiosError(err), () => navigate(urls.home()), { title: "订单加载失败" });
    } finally {
      loading.hide();
    }
  }, [orderNo, navigate]);

  useEffect(() => {
    getPayOrder();
  }, [getPayOrder]);

  return (
    <div>
      { order != null &&
        <div>
          <Preview className="pt-5 mb-5">
            <div className="text-center">{ order.isPay ? <IconSuccess className="text-3xl" msg></IconSuccess> : <IconCancel className="text-3xl" msg></IconCancel> }</div>
            <h2 className="weui-msg__title text-center">{ order.isPay ? "支付成功" : "支付失败" }</h2>
            <hr></hr>
            <PreviewBody>
              <PreviewItem label="订单编号">{ order?.orderNo }</PreviewItem>
              <PreviewItem label="支付金额">{ formatCurrency(order?.totalMoney) } 元</PreviewItem>
              <PreviewItem label="支付方式">{ order?.payChannel }</PreviewItem>
              <PreviewItem label="订单时间">{ order ? formatDateTime(new Date(order?.createTime)) : "" }</PreviewItem>
            </PreviewBody>
          </Preview>
          <div className="mt-10">
            <Button type="primary" onClick={ e => navigate(urls.paymentDetail(orderNo)) }>查看订单</Button>
          </div>
        </div>
      }
    </div>
  );
};
